<template>
    <section :class="sectionClass">
        <p>
            <router-link v-if="showLink" :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
            <input
                v-if="$_updateActionAllowed"
                type="submit"
                :value="rightButtonTitle"
                :class="['btn']"
                @click.prevent.stop="emitSubmitForm()"
            >
        </p>
    </section>
</template>

<script>
	export default {
		name: "DetailBottomButtons",
		props: {
			moduleName: String,
			sectionClass: {
				type: String,
				default: 'buttons',
			},
			showLink: {
				type: Boolean,
				default: true,
			},
            buttonTitle: {
				type: String,
                default: null
            }
		},
        computed: {
            rightButtonTitle() {
                return this.buttonTitle || this.$gettext('Uložit');
            }
        },
		methods: {
			emitSubmitForm(value = false) {
				this.$emit('submit-form', value)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/common/DetailBottomButtons.vue